<template>
  <div class="chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || "";
              if (label) {
                label += ": ";
              }
              if (tooltipItem.yLabel) {
                label += new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(tooltipItem.yLabel);
              }
              return label;
            },
          },
        },
      }),
    },
  },
  mounted() {
    // Check if we have data before rendering
    if (
      this.chartData &&
      this.chartData.datasets &&
      this.chartData.datasets.length > 0 &&
      this.chartData.labels &&
      this.chartData.labels.length > 0
    ) {
      this.renderChart(this.chartData, this.options);
    } else {
      // Render empty state
      this.renderChart(
        {
          labels: ["No Data Available"],
          datasets: [
            {
              label: "Revenue",
              data: [0],
              backgroundColor: "rgba(200, 200, 200, 0.2)",
              borderColor: "rgba(200, 200, 200, 1)",
              borderWidth: 1,
              pointRadius: 0,
            },
          ],
        },
        {
          ...this.options,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: (value) => {
                    return "$" + value.toLocaleString();
                  },
                },
              },
            ],
          },
        }
      );
    }
  },
};
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}
</style>
